import React from 'react'
import { Card, Col, Container, Row, Button } from 'react-bootstrap'
import AddClinicForm from '../components/form/AddClinicForm'

const AddClinic = () => {
  return (
    <>
   <Container> 
    <Row className='justify-content-center'>
        <Col md={10}>
            <Card className=' shadow-sm px-5 pt-5 pb-3 ' border='0'>
                <Row>
                    <Col>
                        <h2 className='text-secondary'>Add Clinic</h2>
                    </Col>
                </Row>
                <Row className='mt-4'>
                    <Col>
                        <AddClinicForm />
                    </Col>
                </Row>
            </Card>  
        </Col>
    </Row>
    </Container>
   </>
  )
}

export default AddClinic
